import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrap = styled.div<{ $paddingBottom?: string; $paddingTop?: string }>`
  .isDesktopStyle & {
    padding: ${({ $paddingBottom, $paddingTop }) =>
      `${$paddingTop || '24px'} 24px ${$paddingBottom || '24px'} 24px`};
  }
  .isMobileStyle & {
    padding: ${({ $paddingBottom, $paddingTop }) =>
      `${$paddingTop || '24px'} 8px ${$paddingBottom || '24px'} 8px`};
  }
`;

interface Props {
  children?: ReactNode;
  paddingBottom?: string;
  paddingTop?: string;
}

/**
 * Modal content wrapper with standard padding
 *  - only use if using modal without any padding
 *    and/or with footer
 */
export default function ModalContent({
  children,
  paddingTop,
  paddingBottom,
}: Props) {
  return (
    <Wrap $paddingTop={paddingTop} $paddingBottom={paddingBottom}>
      {children}
    </Wrap>
  );
}
